/*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
export const getRecaptchaWidgetId = state => state.recaptcha.widgetId;
/*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
export const getRecaptchaToken = state => state.recaptcha.token;